import { UserSvg } from '../svg/user.svg';
import { IconPropsDeprecated } from '@umanforge/common';

export const MyTasksIcon = ( { className = 'w-5 h-5 text-green-600', size, onClick }: IconPropsDeprecated ) => {
  return (
    <UserSvg
      className={ className }
      size={ size }
      onClick={ onClick }
    />
  );
};
